import { TnPortalType } from './portal-type';

export interface TnOrderInput {
  reservationCustomerId?: number;
  accountId: number;
  portalType: TnPortalType;
  pon?: string;
  portalUserId?: number;
  tns?: string[] // deprecated
  tnE164s?: string[]
}

export interface TnOrderResponse {
  tnsOrdered: string[]
  tnsNotOrdered: string[]
  tnE164sOrdered: string[]
  tnE164sNotOrdered: string[]
  orderId: string;
  tnOrder?: TnOrder;
}

interface TnOrder {
  id: string;
  displayId: string;
  type?: string;
  accountId: number;
  accountName?: string;
  userId?: number;
  userEmail?: string;
  pon?: string;
  status: string;
  createdAt?: Date;
  updatedAt?: Date;
  tns: [TnOrderNumber];
}

interface TnOrderNumber {
  id: string;
  orderId: string;
  tn: string;
  tnE164?: string;
  status: string;
  statusMsg?: string;
  // provisionOrder: TnProvisionOrder;
  // currentSettings: TnProvisionSettings;
  // pendingSettings: TnProvisionSettings;
}

export interface TnModifyTnsResult {
  tnOrderResponse: {
    orderId: string
  }
}

export const ORDER_TYPE = {
  NEW: 'NEW',
  CHANGE: 'CHANGE',
  CHANGE_ACCOUNT: 'CHANGE_ACCOUNT',
  DELETE: 'DELETE',
  DISCONNECT: 'DISCONNECT',
}

export const TN_PROVISION_TYPE = {
  NEW: 'NEW',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DISCONNECT: 'DISCONNECT',
}

export const ORDER_TYPE_TO_PROV_TYPE_MAP = {
  'NEW': 'NEW',
  'CHANGE': 'UPDATE',
  'CHANGE_ACCOUNT': 'UPDATE',
  'DELETE': 'DELETE',
  'DISCONNECT': 'DISCONNECT',
}

export function getProvTypeFromOrderType(orderType: string) {
  if (Object.keys(ORDER_TYPE_TO_PROV_TYPE_MAP).includes(orderType)) {
    return ORDER_TYPE_TO_PROV_TYPE_MAP[orderType as keyof typeof ORDER_TYPE_TO_PROV_TYPE_MAP];
  }
  return null;
}
